<template>
  <div class="week-by-car-num">
    <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <div class="wrapper">
      <el-tabs v-model="activeTab" @tab-click="onTabChange">
        <el-tab-pane label="周度统计" name="week"></el-tab-pane>
        <el-tab-pane label="月度统计" name="month"></el-tab-pane>
      </el-tabs>
      <div class="header">
        <el-form :inline="true" label-width="60px">
          <template v-if="activeTab === 'week'">
            <el-form-item label="统计周" label-width="75px">
              <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="统计月" label-width="75px">
              <el-date-picker
                v-model="monTime"
                type="month"
                :clearable="false"
                placeholder="选择月"
                value-format="yyyy-MM"
                style="width: 180px;"
              />
            </el-form-item>
          </template>
          <el-form-item label="省份" label-width="75px">
            <el-cascader
                v-if="areaListPr.length>0"
                :options="areaListPr"
                v-model="formData.provCityCounty"
                :props="propsData()"
                clearable></el-cascader>
          </el-form-item>
          <el-button style="margin-left:30px;" @click="getData(true)">查询</el-button>
          <el-button style="margin-left:20px;" @click="onExportCommand">导出</el-button>
        </el-form>
      </div>
      <el-table ref="singleTable" :data="tableData" :max-height="tableHeight+52" stripe style="width: 100%">
        <el-table-column type="index" label="序号" :index="indexMethod" align="center" width="50" fixed="left">
        </el-table-column>
        <el-table-column prop="provinceName" label="单位" align="center"></el-table-column>
        <el-table-column label="整体情况" align="center">
          <template slot="header" slot-scope="scope">
            <div class="headerSty">
              <div>{{ '整体情况' }}</div>
              <div>{{ '2024年6月24日-' + endTime }}</div>
            </div>
          </template>
          <el-table-column prop="devFinishNum" label="已开发" align="center"></el-table-column>
          <el-table-column prop="successRate" label="开发成功率" align="center"></el-table-column>
          <el-table-column prop="devDuringNum" label="开发中" align="center"></el-table-column>
          <el-table-column prop="devStopNum" label="终止开发" align="center"></el-table-column>
          <el-table-column prop="devStopRate" label="终止开发率" align="center"></el-table-column>
          <el-table-column prop="receiveCustomerNum" label="已领取" align="center"></el-table-column>
          <el-table-column prop="receiveCustomerRate" label="客户领取率" align="center"></el-table-column>
          <el-table-column prop="unreceiveCustomerNum" label="未开发" align="center"></el-table-column>
        </el-table-column>
        <el-table-column v-if="activeTab === 'week'" label="近一周情况" align="center">
          <template slot="header" slot-scope="scope">
            <div class="headerSty">
              <div>{{ '近一周情况' }}</div>
              <div>{{ startTime + '-' + endTime }}</div>
            </div>
          </template>
          <el-table-column prop="addDevFinishNum" label="新增开发成功数" align="center"></el-table-column>
          <el-table-column prop="addDevFinishNumRate" label="新增开发成功数周环比" width="170"
                           align="center"></el-table-column>
          <el-table-column prop="managerLoginCountRate" label="客户经理登录率" align="center"></el-table-column>
        </el-table-column>
        <el-table-column v-else label="当月情况" align="center">
          <template slot="header" slot-scope="scope">
            <div class="headerSty">
              <div>{{ '当月情况' }}</div>
              <div>{{ monthLabel }}</div>
            </div>
          </template>
          <el-table-column prop="addDevFinishNum" label="当月已开发" align="center"></el-table-column>
          <el-table-column prop="lastAddDevFinishNum" label="上月已开发" width="170"
                           align="center"></el-table-column>
          <el-table-column prop="addDevFinishNumRate" label="月环比" align="center"></el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import WeekPopover from '../components/weekPopover.vue'
import {sumFindPage, monthSumFindPage, devSummaryExp, devSummaryMonthExp} from "@/api/log";
import http from '@/api/freight'

export default {
  name: 'week-by-car-num',
  components: {WeekPopover},
  data() {
    const now = new Date()
    const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1)
    const monthNum = lastMonth.getMonth() + 1
    const defaultMonTime = `${lastMonth.getFullYear()}-${monthNum < 10 ? '0' + monthNum : monthNum}`
    return {
      activeTab: 'week',
      mark: false,
      progressNum: 0,
      formData: {
        provCityCounty: [],
      },
      monTime: defaultMonTime,
      startTime: '',
      endTime: '',
      monthLabel: '',
      areaListPr: [],
      tableData: [],
      index: 1,
      pageSize: 20,
    }
  },
  mounted() {
    this.getPrInter()
  },
  methods: {
    indexMethod(index) {
      if (index === 0 && this.tableData[index].provinceName == '全国') {
        return '合计';
      } else {
        if (this.tableData[0].provinceName != '全国') {
          return index + 1;
        } else {
          return index;
        }
      }
    },
    async getPrInter() {
      const {data} = await http.getCountyAreaList({code: '0', type: '1', areaType: 'PROVINCE'})
      this.areaListPr = data
          .map(item => ({
            value: item.code,
            label: item.name,
            leaf: false
          }));
    },
    propsData() {
      return {
        lazy: false,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          resolve([])
        }
      }
    },
    formatDate(dateStr) {
      const year = dateStr.slice(0, 4);
      const month = dateStr.slice(4, 6);
      const day = dateStr.slice(6, 8);
      return `${year}年${month}月${day}日`;
    },
    formatMonthLabel(monTime) {
      if (!monTime) {
        return ''
      }
      const parts = monTime.split('-')
      return `${parts[0]}年${parts[1]}月`
    },
    onTabChange() {
      this.tableData = []
      this.startTime = ''
      this.endTime = ''
      this.monthLabel = ''
      if (this.activeTab === 'week') {
        this.$nextTick(() => {
          if (this.$refs.weekPopoverRef && this.$refs.weekPopoverRef.curSelectedWeek) {
            this.getData(true)
          }
        })
      } else {
        this.getData(true)
      }
    },
    getData(flag) {
      if (flag) {
        this.index = 1
      }
      const params = {
        provinceCode: this.formData.provCityCounty[0] || '',
        pageNum: this.index,
        pageSize: this.pageSize,
      }
      if (this.activeTab === 'week') {
        const curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
        if (!curSelectedWeek) {
          this.$message({
            message: '请选择周',
            type: 'warning',
          })
          return
        }
        Object.assign(params, curSelectedWeek)
        sumFindPage(params)
            .then((e) => {
              this.handleListResponse(e)
            })
            .catch((err) => {
              console.error(err)
            })
      } else {
        if (!this.monTime) {
          this.$message({
            message: '请选择月',
            type: 'warning',
          })
          return
        }
        const parts = this.monTime.split('-')
        params.year = parts[0]
        params.month = parts[1]
        this.monthLabel = this.formatMonthLabel(this.monTime)
        monthSumFindPage(params)
            .then((e) => {
              this.handleListResponse(e)
            })
            .catch((err) => {
              console.error(err)
            })
      }
    },
    handleListResponse(e) {
      if (200 != e.code) {
        this.$message({
          message: e.message || '数据获取出错',
          type: 'error',
        })
        return
      }
      this.tableData = e.data
      if (e.data && e.data.length > 0) {
        this.endTime = this.formatDate(e.data[0].weekEnd)
        if (this.activeTab === 'week') {
          this.startTime = this.formatDate(e.data[0].weekStart)
        }
      }
    },
    onWeekPopOverCommand(params) {
      if (params.type === 'default-week' && this.activeTab === 'week') {
        this.getData(true)
      }
    },
    onExportCommand() {
      const provinceCode = this.formData.provCityCounty[0] || ''
      if (this.activeTab === 'week') {
        const curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
        if (!curSelectedWeek) {
          this.$message({
            message: '请选择周',
            type: 'warning',
          })
          return
        }
        window.location.assign(devSummaryExp({
          ...curSelectedWeek,
          provinceCode,
        }))
      } else {
        if (!this.monTime) {
          this.$message({
            message: '请选择月',
            type: 'warning',
          })
          return
        }
        const parts = this.monTime.split('-')
        window.location.assign(devSummaryMonthExp({
          year: parts[0],
          month: parts[1],
          provinceCode,
        }))
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.headerSty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    line-height: 20px;
  }
}

.wrapper {
  padding: 20px;
  background: #fff;

  .header {
    margin-bottom: 20px;
  }
}
</style>
